const creator = {
  //创客
  path: 'creator',
  component: () => import("@/views/member/creator/creator"),
  meta: {
    tabBar: 'home'
  },
  children: [
    // 填写炭币的收货地址
    {
      //赠品管理
      path: 'ck-gift-manage',
      component: () => import("@/views/member/creator/ck-gift-manage"),
      meta: {
        tabBar: false
      }
    }, {
      //赠品明细
      path: 'ck-gift-detail',
      component: () => import("@/views/member/creator/ck-gift-detail"),
      meta: {
        tabBar: false
      }
    }, {
      //辅导收益
      path: 'tanbi-submit-state',
      component: () => import("@/views/member/creator/tanbi-submit-state.vue"),
      meta: {
        tabBar: false
      }
    }, {
      //辅导收益
      path: 'tanbi-form-fill',
      component: () => import("@/views/member/creator/tanbi-form-fill"),
      meta: {
        tabBar: false
      }
    },
    {
      //辅导收益
      path: 'gift-form-fill',
      component: () => import("@/views/member/creator/gift-form-fill"),
      meta: {
        tabBar: 'home'
      }
    },{
      //辅导收益
      path: 'coach-income',
      component: () => import("@/views/member/creator/coach-income")
    }, {
      //辅导收益明细
      path: 'coach-income-detail',
      component: () => import("@/views/member/creator/coach-income-detail"),
      meta: {
        tabBar: false
      }
    }, {
      //待收益
      path: 'wait-settle',
      component: () => import("@/views/member/creator/wait-settle")
    }, {
      //商城收益
      path: 'shop-income',
      component: () => import("@/views/member/creator/shop-income")
    }, {
      //商城收益明细
      path: 'shop-income-detail',
      component: () => import("@/views/member/creator/shop-income-detail"),
      meta: {
        tabBar: false
      }
    }, {
      //我的社群
      path: 'association',
      component: () => import("@/views/member/creator/association")
    }, {
      //添加社群
      path: 'association-add',
      component: () => import("@/views/member/creator/association-add"),
      meta: {
        tabBar: false
      }
    }, {
      //申请证书
      path: 'apply-for',
      component: () => import("@/views/member/creator/apply-for"),
      meta: {
        tabBar: false
      }
    }, {
      //已申请证书
      path: 'on-apply-for',
      component: () => import("@/views/member/creator/on-apply-for"),
      meta: {
        tabBar: false
      }
    }, {
      //创客身份升级
      path: 'creator-up',
      component: () => import("@/views/member/creator/creator-up"),
      meta: {
        tabBar: false
      }
    }, {
      //累计通宝收益
      path: 'tb-earnings',
      component: () => import("@/views/member/creator/tb-earnings"),
      meta: {
        // tabBar: false
      }
    }, {
      //招募辅导师收益
      path: 'recruit-ck-earnings',
      component: () => import("@/views/member/creator/recruit-ck-earnings"),
      meta: {
        // tabBar: false
      }
    }, {
      //招募vip收益
      path: 'recruit-vip-earnings',
      component: () => import("@/views/member/creator/recruit-vip-earnings"),
      meta: {
        // tabBar: false
      }
    }, {
      //招募美丽天使收益
      path: 'recruit-angel-earnings',
      component: () => import("@/views/member/creator/recruit-angel-earnings"),
      meta: {
        // tabBar: false
      }
    }, {
      //招募项目金主收益
      path: 'recruit-owner-earnings',
      component: () => import("@/views/member/creator/recruit-owner-earnings"),
      meta: {
        // tabBar: false
      }
    }, {
      //优秀辅导师评定标准
      path: 'evaluate-norm',
      component: () => import("@/views/member/creator/evaluate-norm"),
      meta: {
        // tabBar: false
      }
    }, {
      // 我的进度
      path: 'my_progress',
      component: () => import("@/views/member/creator/my_progress"),
      meta: {
        // tabBar: false
      }
    }, {
      //招募粮芯奶会员收益
      path: 'recruit-lxn-earnings',
      component: () => import("@/views/member/creator/recruit-lxn-earnings"),
      meta: {
        // tabBar: false
      }
    }, {
      //领取赠品
      path: 'get-gift',
      component: () => import("@/views/member/creator/get-gift"),
      meta: {
        // tabBar: false
      }
    },
  ]
};

export default creator;
